// @flow

import React from 'react';
import styles from './CancelConfigurationModal.module.css';
import Button from '../ui/Button';
import BaseModal from './BaseModal';

type Props = {
  onSubmit: Function,
  onClose: Function,
};

export default ({ onSubmit, onClose }: Props) => (
  <BaseModal onClose={onClose} title="Cancel Changes">
    <div className={styles.infoText}>
      Your changes will not be saved. Are you sure you would exit the
      configuration?
    </div>
    <div className={styles.buttonGroup}>
      <Button onClick={() => onSubmit()} primary>
        Yes
      </Button>
      <Button onClick={onClose} secondary>
        No
      </Button>
    </div>
  </BaseModal>
);
